import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger, } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import { WorkflowTaskModel } from '../../../api/model/common/workflowTask.model';
import { WorkflowTaskConverter } from '../../../api/model/common/converter/workflowTask.converter';
import { CustomizeHttpUrlGenerator } from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class WorkflowTaskDataService extends AbstractDataServiceV2<WorkflowTaskModel, WorkflowTaskConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
        converter: WorkflowTaskConverter) {
        super('WorkflowTask', http, httpUrlGenerator, logger, config, converter);
    }
}
